// ***** Library Imports *****
import { Outlet } from "react-router-dom";
import { ToastProvider } from "@/providers/toast-provider";

const RootLayout = () => {
  return (
    <>
      <Outlet />
      <ToastProvider />
    </>
  );
};

export default RootLayout;
